import { useQuery } from '@tanstack/react-query';
import { Link, useLocation } from 'react-router';
import { useShell } from './shellContext';
import styles from './AnalysisScopeNotice.module.css';

export function AnalysisScopeNotice() {
  const { account, queries } = useShell();
  const { pathname } = useLocation();
  const settings = useQuery(queries.settings(account.id));
  const count = settings.data?.data.excludedCampaignIds?.length ?? 0;
  if (!count || pathname === '/settings') return null;
  return (
    <div className={styles.notice} role="status">
      <span>
        Analysis excludes {count} {count === 1 ? 'campaign' : 'campaigns'} and their ad sets and
        ads.
      </span>
      <Link to="/settings#settings-results">Manage exclusions</Link>
    </div>
  );
}
